import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core'
import {Observable} from 'rxjs';
import {environment} from "../../../../../../environments/environment";
import {Payload} from "../../../../core/service/payload/payload";

@Injectable()
export class SpellCheckTextService {
    constructor(private httpClient: HttpClient) {
    }

    execute(payload: SpellCheckTextServicePayload): Observable<SpellCheckTextServiceResult> {
        return this.httpClient.post<SpellCheckTextServiceResult>(environment.webserviceUrl + '/api/communication/ai/text-spell-check',
            payload);
    }
}

export class SpellCheckTextServicePayload implements Payload {
    text: string;

}

export class SpellCheckTextServiceResult {
    text: string;
}
